import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import axios from "axios";

// // console.log("env: " + process.env.NODE_ENV);
if (process.env.NODE_ENV !== "development") {
  // axios.defaults.baseURL = "http://127.0.0.1:4001";
  axios.defaults.baseURL = "http://3.123.182.119:5000";
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
